import { StartTimeType } from './TimeFilter.types'

// Can't automatically generate these values from the type
export const START_TIME_OPTIONS: Array<StartTimeType> = [
  600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200, 2300,
]
